import _ from 'underscore';
import { useEffect, useState, useCallback, useMemo } from 'react';
import { McaChannelTypes, McaSocialChannelTypes } from '@bingads-webui-campaign-react/mca-core';
import { useSocialProfiles as useSocialProfilesOverreactHook } from '@bingads-webui/overreact-odata-multi-channel';

import { useAccountLevelVariables, useSocialProfilesVariablesOptions } from './use-variables';

const DEFAULT_CONFIG = {};

const socialChannelTypesFilter = _.chain(McaSocialChannelTypes)
  .map(ct => `ChannelType eq Enum.ChannelType'${ct}'`)
  .join(' or ')
  .value();

const internalChannelTypeFilter = `ChannelType eq Enum.ChannelType'${McaChannelTypes.Internal}'`;

export const useSocialProfiles = (props, config = DEFAULT_CONFIG) => {
  const { shouldAutoRead, variables } = props || {};
  const [shouldRead, setShouldRead] = useState(shouldAutoRead);
  const [isLoading, setIsLoading] = useState(false);

  const socialProfileVariables = useSocialProfilesVariablesOptions({
    filter: { where: socialChannelTypesFilter },
    ...variables,
  });
  const accountLevelVariables = useAccountLevelVariables(socialProfileVariables);

  const [entityState, actions] = useSocialProfilesOverreactHook(accountLevelVariables, config);
  const { data } = entityState;
  const { loadMore } = actions;

  const onFetchComplete = useCallback(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (shouldRead && !data && !isLoading) {
      setIsLoading(true);
      loadMore({
        onComplete: onFetchComplete,
        onError: onFetchComplete,
      });
      setShouldRead(false);
    }
  }, [data, isLoading, onFetchComplete, loadMore, shouldRead]);

  const dataSet = useMemo(() => _.extend({}, entityState, { isLoading }), [entityState, isLoading]);

  return [dataSet, actions];
};

export const useInternalSocialProfiles = (props) => {
  const { shouldAutoRead } = props || {};
  const [shouldRead, setShouldRead] = useState(shouldAutoRead);
  const [isLoading, setIsLoading] = useState(false);

  const socialProfileVariables = useSocialProfilesVariablesOptions({
    filter: { where: internalChannelTypeFilter },
  });
  const accountLevelVariables = useAccountLevelVariables(socialProfileVariables);

  const [entityState, actions] = useSocialProfilesOverreactHook(accountLevelVariables);
  const { data } = entityState;
  const { loadMore } = actions;

  const onFetchComplete = useCallback(() => setIsLoading(false), []);

  useEffect(() => {
    if (shouldRead && !data && !isLoading) {
      setIsLoading(true);
      loadMore({
        onComplete: onFetchComplete,
        onError: onFetchComplete,
      });
      setShouldRead(false);
    }
  }, [data, isLoading, onFetchComplete, loadMore, shouldRead]);

  return [entityState, actions];
};
